import React from 'react';
import { ButtonSize, SpinnerColor } from '@/services/enums';

interface LoadingSpinnerProps {
  size?: ButtonSize;
  color?: SpinnerColor;
  text?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 'md', color = 'cyan', text }) => {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  const colorClasses = {
    cyan: 'border-cyan-400',
    purple: 'border-purple-400',
    pink: 'border-pink-400',
    green: 'border-green-400',
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="relative">
        {/* 外圈旋转 */}
        <div
          className={`
            ${sizeClasses[size]} 
            border-2 border-transparent 
            ${colorClasses[color]} 
            border-t-2 
            rounded-full 
            animate-spin
          `}
        />

        {/* 内圈反向旋转 */}
        <div
          className={`
            absolute inset-1 
            border-2 border-transparent 
            ${colorClasses[color]} 
            border-b-2 
            rounded-full 
            animate-spin
          `}
          style={{ animationDirection: 'reverse', animationDuration: '0.8s' }}
        />

        {/* 中心点 */}
        <div
          className={`
            absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2
            w-1 h-1 
            ${
              color === 'cyan'
                ? 'bg-cyan-400'
                : color === 'purple'
                  ? 'bg-purple-400'
                  : color === 'pink'
                    ? 'bg-pink-400'
                    : 'bg-green-400'
            }
            rounded-full
            animate-pulse
          `}
        />
      </div>

      {text && <p className="mt-3 text-white/70 text-sm font-medium animate-pulse">{text}</p>}
    </div>
  );
};

export default LoadingSpinner;
